export const charData = [
  {
    name: "Abigail",
    title: "Champion of the Egg Hunt",
    birthday: "Fall 13",
    gender: "gal",
    image: "./img/Abigail.png",
    id: 834102,
    loves: [
      "amethyst",
      "pumpkin",
      "pufferfish",
      "chocolate cake",
      "blackberry cobbler",
      "spicy eel",
      "banana pudding",
      "Monster Compendium",
    ],
    likes: [
      "quartz",
      "ancient sword",
      "basilisk paw",
      "bone flute",
      "Combat Quarterly",
    ],
    hates: ["vegetables"],
  },
  {
    name: "Alex",
    title: "Pro Gridball Hopeful",
    birthday: "Summer 13",
    gender: "guy",
    image: "./img/Alex.png",
    id: 457203,
    loves: ["complete breakfast", "salmon dinner", "Jack Be Nimble"],
    likes: ["egg", "dinosaur egg", "duck egg", "parrot egg", "field snack"],
    hates: ["none"],
  },
  {
    name: "Clancy",
    title: "Earth Science Researcher",
    birthday: "Fall 3",
    gender: "guy",
    image: "./img/Clancy.png",
    id: 220475,
    loves: [
      "all minerals",
      "rainbow shell",
      "void egg",
      "fish taco",
      "artichoke dip",
      "chocolate cake",
    ],
    likes: [
      "all artifacts",
      "espresso",
      "honey",
      "diamond",
      "orange",
      "tropical curry",
    ],
    hates: ["melon", "all milk", "coleslaw", "pickles"],
  },
  {
    name: "Davy",
    title: "Image Designer",
    birthday: "Winter 11",
    gender: "gal",
    image: "./img/Davy.png",
    id: 970664,
    loves: [
      "corn",
      "iridium bar",
      "truffle",
      "ostrich egg",
      "duck feather",
      "all flowers",
    ],
    likes: ["ruby", "dinosaur egg", "all cheese"],
    hates: ["coffee", "orange", "grapes"],
  },
  {
    name: "Elliott",
    title: "Aspiring Author",
    birthday: "Fall 5",
    gender: "guy",
    image: "./img/Elliott.png",
    id: 112435,
    loves: [
      "pomegranate",
      "lobster",
      "duck feather",
      "crab cakes",
      "tom kha soup",
      "squid ink",
    ],
    likes: [
      "all fruit crops",
      "all foraged fruits (no salmonberry)",
      "octopus",
      "squid",
      "all books",
    ],
    hates: ["amaranth", "pizza", "rainbow shell"],
  },
  {
    name: "Emily",
    title: "Waitress, Tailor, Dancing Queen",
    birthday: "Spring 27",
    gender: "gal",
    image: "./img/Emily.png",
    id: 998754,
    loves: [
      "wool",
      "cloth",
      "parrot egg",
      "survival burger",
      "emerald",
      "aquamarine",
      "ruby",
      "amethyst",
      "topaz",
      "jade",
    ],
    likes: ["daffodil", "quartz"],
    hates: [
      "ice cream",
      "sashimi",
      "fried eel",
      "spicy eel",
      "rice pudding",
      "salmon dinner",
      "fish taco",
      "maki roll",
    ],
  },
  {
    name: "Haley",
    title: "Hobbyist Photographer",
    birthday: "Spring 14",
    gender: "gal",
    image: "./img/Haley.png",
    id: 554332,
    loves: ["coconut", "sunflower", "fruit salad", "pink cake"],
    likes: ["daffodil"],
    hates: ["vegetables", "prismatic shard"],
  },
  {
    name: "Harvey",
    title: "Town Doctor",
    birthday: "Winter 14",
    gender: "guy",
    image: "./img/Harvey.png",
    id: 301836,
    loves: ["coffee", "pickles", "truffle oil", "wine", "super meal"],
    likes: [
      "daffodil",
      "dandelion",
      "all fruit crops",
      "all foraged fruits",
      "most forageables",
      "most mushrooms",
      "duck egg",
      "duck feather",
      "goat milk",
      "quartz",
    ],
    hates: [
      "all cheese",
      "fried mushroom",
      "hashbrowns",
      "pizza",
      "ice cream",
      "pink cake",
      "most sugary foods",
      "chocolate cake",
    ],
  },
  {
    name: "Leah",
    title: "Aspiring Artist",
    birthday: "Winter 23",
    gender: "gal",
    image: "./img/Leah.png",
    id: 257683,
    loves: [
      "truffle",
      "goat cheese",
      "wine",
      "poppyseed muffin",
      "salad",
      "stir fry",
      "vegetable medley",
    ],
    likes: [
      "daffodil",
      "dandelion",
      "all forageables",
      "all fruits",
      "most mushrooms",
      "all milk",
      "egg",
      "duck egg",
      "driftwood",
    ],
    hates: [
      "all gems (no diamond)",
      "pancakes",
      "hashbrowns",
      "carp surprise",
      "pizza",
      "cookies",
      "ice cream",
      "pink cake",
      "rice pudding",
      "survival burger",
      "tortilla",
    ],
  },
  {
    name: "Lou",
    title: "Web Designer / Developer",
    birthday: "Fall 26",
    gender: "guy",
    image: "./img/Lou.png",
    id: 110293,
    loves: [
      "maple syrup",
      "rice",
      "tilapia",
      "apple",
      "pumpkin",
      "all mayonnaise",
    ],
    likes: ["ice cream", "sashimi", "battery pack", "iridium bar"],
    hates: ["coffee", "all minerals", "all artifacts"],
  },
  {
    name: "Maru",
    title: "Nurse, Master Roboticist",
    birthday: "Summer 10",
    gender: "gal",
    image: "./img/Maru.png",
    id: 654534,
    loves: [
      "cauliflower",
      "strawberry",
      "cheese cauliflower",
      "miner's treat",
      "pepper poppers",
      "rhubarb pie",
      "diamond",
      "gold bar",
      "iridium bar",
      "radioactive bar",
      "battery pack",
    ],
    likes: [
      "copper bar",
      "iron bar",
      "quartz",
      "oak resin",
      "pine tar",
      "most mushrooms",
      "radioactive ore",
    ],
    hates: ["maple syrup", "honey", "pickles"],
  },
  {
    name: "Penny",
    title: "Tutor",
    birthday: "Fall 2",
    gender: "gal",
    image: "./img/Penny.png",
    id: 905523,
    loves: [
      "melon",
      "poppy",
      "poppyseed muffin",
      "sandfish",
      "red plate",
      "tom kha soup",
      "roots platter",
      "diamond",
      "emerald",
      "all books",
    ],
    likes: ["leek", "dandelion", "all milk", "all artifacts"],
    hates: [
      "alcoholic drinks",
      "pina colada",
      "pale broth",
      "algae soup",
      "rabbit's foot",
    ],
  },
  {
    name: "Sam",
    title: "Rock Star in Training",
    birthday: "Summer 17",
    gender: "guy",
    image: "./img/Sam.png",
    id: 232202,
    loves: ["cactus fruit", "maple bar", "pizza", "tigerseye"],
    likes: ["joja cola", "egg", "duck egg"],
    hates: ["vegatables", "all mayonnaise", "pickles"],
  },
  {
    name: "Sebastian",
    title: "Computer Enthusiast",
    birthday: "Winter 10",
    gender: "guy",
    image: "./img/Sebastian.png",
    id: 182750,
    loves: [
      "frog egg",
      "void egg",
      "sashimi",
      "pumpkin soup",
      "frozen tear",
      "obsidian",
    ],
    likes: ["quartz", "flounder", "Combat Quarterly", "Monster Compendium"],
    hates: [
      "omelet",
      "complete breakfast",
      "farmer's lunch",
      "alcoholic drinks",
      "juice",
      "all flowers",
      "artisan goods",
    ],
  },
  {
    name: "Shane",
    title: "Joja Stockboy, Chicken Whisperer",
    birthday: "Spring 20",
    gender: "guy",
    image: "./img/Shane.png",
    id: 785332,
    loves: ["hot pepper", "beer", "pizza", "pepper poppers"],
    likes: ["fruit crops", "foraged fruits", "egg", "duck egg"],
    hates: ["pickles"],
  },

  {
    name: "Trena",
    title: "Web Developer",
    birthday: "Summer 16",
    gender: "gal",
    image: "./img/Trena.png",
    id: 801777,
    loves: ["potato", "all books", "all artifacts", "maple bar", "all dolls"],
    likes: [
      "joja cola",
      "all minerals",
      "all flowers",
      "chocolate cake",
      "apple",
      "pizza",
    ],
    hates: ["most vegetables", "salad", "all fish"],
  },
];
